const SELECT2_SKIP = '[data-select2-config], [data-no-select2], .select2-hidden-accessible, .dataTables_length select'

window.initSelect2 = function (root = document) {
  $(root)
    .find('select')
    .not(SELECT2_SKIP)
    .each(function () {
      const $select = $(this)
      const $modal = $select.closest('.modal')
      const placeholder = this.dataset.placeholder
      const $dropdownParent = $modal.find('.modal-dialog-scrollable').length
        ? $modal
        : $modal.find('.modal-content').first()

      $select.select2({
        width: '100%',
        language: 'es',
        ...(placeholder ? { placeholder } : {}),
        ...($modal.length ? { dropdownParent: $dropdownParent } : {})
      })
    })
}

$(document).on('reset', 'form', function () {
  const form = this
  setTimeout(() => $(form).find('select.select2-hidden-accessible').trigger('change.select2'), 0)
})

$(function () {
  $('select[data-select2-config]').each(function () {
    const $select = $(this)
    const config = JSON.parse(this.dataset.select2Config || '{}')
    if (config.dropdownParent) {
      const $parent = $(config.dropdownParent)
      config.dropdownParent = $parent.is('.modal') ? $parent.find('.modal-content').first() : $parent
    }
    $select.select2(config)

    if (this.dataset.oldValues) {
      const oldValues = JSON.parse(this.dataset.oldValues)
      $select.find('option').each(function () {
        const value = $(this).val() || $(this).text()
        $(this).prop('selected', oldValues.includes(value))
      })
      $select.trigger('change')
    }
  })

  window.initSelect2()

  $('input[data-flatpickr]').each(function () {
    const value = this.dataset.initialValue ? JSON.parse(this.dataset.initialValue) : ''
    $(this).flatpickr(JSON.parse(this.dataset.flatpickr || '{}'))
    $(this).val(value || '')
  })
})
